import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getChartDetails } from "../../api/report";
import { transformListing } from "../../utils/listing";
import AveragePricePerSqftChart from "../common/AveragePricePerSqftChart";
import ReportTheme from "../common/ReportTheme";
import useQueryParams from "../common/useQueryParams";

export default function ReportAveragePricePerSqftChart() {
  const queryParams = useQueryParams();
  const [isLoading, setIsLoading] = useState(true);
  const { reportId } = useParams();
  const [listings, setListings] = useState([]);
  const [subjectProperty, setSubjectProperty] = useState({});
  const [theme, setTheme] = useState(undefined);

  const width = queryParams.get("width")
    ? Number(queryParams.get("width"))
    : undefined;
  const height = queryParams.get("height")
    ? Number(queryParams.get("height"))
    : undefined;

  const [showSubjectPropertyIcon, setShowSubjectPropertyIcon] = useState(
    queryParams.get("show_subject_property") !== null
      ? queryParams.get("show_subject_property") === "true"
      : true
  );

  const [showTrendline, setShowTrendline] = useState(
    queryParams.get("show_trendline") !== null
      ? queryParams.get("show_trendline") === "true"
      : true
  );

  const showLegend =
    queryParams.get("show_legend") !== null
      ? queryParams.get("show_legend") === "true"
      : false;

  const showControls =
    queryParams.get("show_controls") !== null
      ? queryParams.get("show_controls") === "true"
      : false;

  useEffect(() => {
    getChartDetails(reportId, "average_price_per_sqft")
      .then((details) => {
        setListings(
          details.listings
            .map(transformListing)
            .filter((listing) => !listing.isHidden)
        );
        setTheme(details.theme);
        setSubjectProperty(details.subjectProperty);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [reportId]);

  if (isLoading) return null;

  return (
    <ReportTheme theme={theme}>
      <AveragePricePerSqftChart
        height={height}
        width={width}
        listings={listings}
        subjectProperty={subjectProperty}
        graphType="home"
        hasLabel
        horizontalLegends
        showSubjectPropertyIcon={showSubjectPropertyIcon}
        setShowSubjectPropertyIcon={setShowSubjectPropertyIcon}
        showTrendline={showTrendline}
        setShowTrendline={setShowTrendline}
        showLegend={showLegend}
        showControls={showControls}
      />
    </ReportTheme>
  );
}
